var map = {
	"./music-instructions.json": 5483,
	"./music-library-intro2024.json": 5484,
	"./music-library-launch2024.json": 5485,
	"./music-progression.json": 5486,
	"./startSourcesAdvanced.json": 5487,
	"./startSourcesSimple.json": 5488,
	"./startSourcesSimple2.json": 5489,
	"./startSourcesTracks.json": 5490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5045;